module.exports = __webpack_public_path__ + "static/media/icon_18.e6cf8591.svg";